// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPageNotLogged_errorPage__1iXJh","errorHeader":"ErrorPageNotLogged_errorHeader__aWynK","contentContainer":"ErrorPageNotLogged_contentContainer__3ZDHz"};